import { Component, OnInit, Input } from '@angular/core';
import Ticket from 'models/ticket/ticket.model';
import { ArcgisMapService } from 'services/arcgis-map/arcgis-map.service';

@Component({
  selector: 'app-ticket-card',
  templateUrl: './ticket-card.component.html',
  styleUrls: ['./ticket-card.component.scss']
})
export class TicketCardComponent implements OnInit {
  @Input() ticket: Ticket = new Ticket();
  constructor(public arcgisMapService: ArcgisMapService) { }

  ngOnInit() {
  }
}
